import { Redirect, Route, useLocation } from 'react-router-dom';

import api from 'api/client';
import React, { useEffect, useState } from 'react';
import { userStore } from 'store/UserStore';
import dashboardService from 'services/dashboard.service';
import { toast } from 'react-toastify';
import { AxiosResponse } from 'axios';
import Loader from 'shared/common/loader';

interface KycFraudResponse {
  kyc_completed: boolean;
  kyc_error?: string | null; // Adjust type based on whether it's always a string or could be null
}

const FraudprivateRoute = ({ component: Component, ...rest }) => {
  const token = api.getToken();
  const [user, customerId] = userStore((state: any) => [
    state.user,
    state.customerId,
  ]);
  const location = useLocation();
  const [isKycFRequired, setIsKycFRequired] = useState(false);
  const [kycError, setKycError] = useState('');
  const [loading, setLoading] = useState(false);

  const KycFraudCompleteFunction = async () => {
    try {
      // const res:AxiosResponse<KycFraudResponse> = await dashboardService.isKYCFraudComplete();
      setLoading(true);
      const response: AxiosResponse<KycFraudResponse> =
        await dashboardService.isKYCFraudComplete();

      // Now access the data within response.data
      const res = response.data;
      if (!res?.kyc_completed) {
        // Adjust based on actual response structure
        setIsKycFRequired(true);
        setKycError(res?.kyc_error);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);

      console.error(error);
      toast.error('Something went wrong');
    }
  };

  useEffect(() => {
    KycFraudCompleteFunction();
  }, []);

  return (
    <>
      {loading && <Loader />}
      <Route
        {...rest}
        render={(props) =>
          !isKycFRequired ? (
            <Component {...props} />
          ) : (
            <Redirect
              to={{
                pathname: '/dashboard',
                state: { isKycRequired: true, kycError: kycError },
              }}
            />
          )
        }
      />
    </>
  );
};

export default FraudprivateRoute;
